module.exports = __webpack_public_path__ + "images/emburse-professional-logo-300.18aecc682003903dc680e269f01ccbea.svg";